export enum ContractStatus {
  created = 'created',
  sending = 'sending',
  sent = 'sent',
  partiallySigned = 'partiallySigned',
  signed = 'signed',
  approved = 'approved',
  rejected = 'rejected',
  voided = 'voided',
  disclosureSent = 'disclosureSent',
  disclosureSigned = 'disclosureSigned',
}

export enum ContractRecipientStatus {
  created = 'created',
  sent = 'sent',
  signed = 'signed',
}

export enum DocusignEnvelopeExportStatus {
  pending = 'Pending',
  requested = 'Requested',
  completed = 'Completed',
}
export enum DocusignContractExportStatus {
  pending = 'Pending',
  requested = 'Requested',
  partiallyComplete = 'Partially Complete',
  completed = 'Completed',
}

export interface DocusignEnvelopeExportInformation {
  envelopeId: string;
  message: string | undefined;
  status: DocusignEnvelopeExportStatus;
}

export interface ContractExportInformation {
  envelopes: DocusignEnvelopeExportInformation[];
  overallStatus: DocusignContractExportStatus;
}
